"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assetMapper = require("../../../lib/assetMapper");

// LHTNG-1817 - Dynamic SVG Loader
var _default = function _default() {
  $(function () {
    try {
      delete $.ajaxSettings.headers['csrf-token'];
      $('.svg.dynamic-loader').each(function (i, el) {
        var $elm = $(el);
        var src = $elm.attr('data-src');

        if (!_(src).isEmpty() && !$elm.html()) {
          $.get((0, _assetMapper.toStaticUrl)("img/".concat(src))).then(function (response) {
            if (!$elm.html()) {
              $elm.append($('svg', response));
            }
          });
        }
      });
    } finally {
      $.ajaxSetup({
        headers: {
          'csrf-token': $('#csrf').val() || OverDrive._csrf
        }
      });
    }
  });
};

exports["default"] = _default;